<script src="https://polyfill.io/v3/polyfill.min.js?flags=gated&features=IntersectionObserver"></script>
<script>

//require('intersection-observer');


export default {
    inserted: (el, binding) => {
        const thresholdArray = steps => Array(steps + 1)
        .fill(0)
        .map((_, index) => index / steps || 0);

        const IntersectionObserverOptions = {
        root: null,
        rootMargin: '0px',
        threshold: thresholdArray(5)
        };

        IntersectionObserver.prototype.POLL_INTERVAL = 100; // Time in milliseconds.


        const targetElement = binding.value.targetElement;
        const className = binding.value.className;
        const toggleClass = binding.value.toggleClass;
        let previousY = 0;
        let previousRatio = 0;
        let observer = new IntersectionObserver(entries => {
            const currentY = entries[0].boundingClientRect.top;
            const currentRatio = entries[0].intersectionRatio;
            const isIntersecting = entries[0].isIntersecting;

            if (entries[0].boundingClientRect.top < 0) {
                if (currentY < previousY) {
                    const items = Array.from(document.querySelectorAll("li.item"));
                    items.forEach(function(element) {
                        element.classList.remove(className);
                    });
                    if (currentRatio > previousRatio) {
                        document.querySelector(targetElement).classList.add(className);
                    } else {
                        document.querySelector(targetElement).classList.add(className);
                    }
                }

            } else {

                if (currentY > previousY) {
                    const items = Array.from(document.querySelectorAll("li.item"));
                    items.forEach(function(element) {
                            element.classList.remove(className);
                        });
                        document.querySelector(targetElement).classList.add(className);

                    if (currentRatio < previousRatio) {
                        document.querySelector(targetElement).classList.add(className);
                    } else {
                        document.querySelector(targetElement).classList.remove(className);
                    }
                }

            }

            previousY = currentY;
            previousRatio = currentRatio;

        }, IntersectionObserverOptions);
        const observerTrigger = binding.value.observerTrigger;
        if (document.querySelector(observerTrigger)) {
            observer.observe(document.querySelector(observerTrigger));
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/components/vue-directives/stickyNav.vue